/**
 * Sentry Error Tracking Initialization
 * This file initializes Sentry for error tracking in the Shopify theme
 */

// Wait for Sentry SDK to be loaded
if (typeof Sentry !== "undefined") {
  // Configure Sentry
  Sentry.onLoad(function () {
    // Set up additional configuration if needed
    Sentry.setContext("shopify", {
      theme: "shift-worship",
      environment: window.Shopify?.shop ? "production" : "development",
      shop: window.Shopify?.shop || "unknown",
    });

    // Set user context if customer is logged in
    if (window.Shopify && window.Shopify.customer) {
      Sentry.setUser({
        id: window.Shopify.customer.id,
        email: window.Shopify.customer.email,
      });
    }

    // Filter out generic "Script error" messages
    // These occur due to CORS restrictions on cross-origin scripts
    Sentry.addEventProcessor(function (event, hint) {
      // Filter out generic script errors that provide no useful information
      if (event.exception && event.exception.values) {
        const firstException = event.exception.values[0];
        if (firstException && firstException.value && firstException.value.includes("Script error")) {
          // Only ignore if there's no stacktrace or useful information
          if (!firstException.stacktrace || !firstException.stacktrace.frames || firstException.stacktrace.frames.length === 0) {
            console.log("Sentry: Ignoring generic 'Script error' with no stack trace");
            return null; // Don't send this event
          }
        }
      }
      return event;
    });

    console.log("Sentry error tracking initialized successfully");
  });
}
